import MaintenanceTemplatesDlg
  from "@/views/maintenance/maintenanceTemplates/maintenanceTemplatesDlg/MaintenanceTemplatesDlg.vue";
import { MaintenanceMixin } from '@/mixins/Maintenance';

export default {
  name: "MaintenanceTemplatesList",
  mixins: [MaintenanceMixin],
  data() {
    return {
      search: "",
      loading: true,
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Date Created',
          align: 'start',
          sortable: false,
          value: 'dateTimeCreated',
        },
      ]
    }
  },
  components: {
    MaintenanceTemplatesDlg
  },
  async mounted() {
    await this.$store.dispatch("getMaintenanceTemplates");
    this.loading = false;
  },
  computed: {
    maintenanceTemplates() {
      return this.$store.state.maintenanceModule.maintenanceTemplates;
    }
  },
  methods: {
    createTemplate() {
      this.$refs.maintenanceTemplatesDlg.open();
    },
    openTemplate(data) {
      this.$router.push(`/maintenanceTemplates/${data.id}`);
    }
  },
}